import type { IconName } from '../components/Icon';

/**
 * Catalogue of equipment types: each one has an icon and a colour used in the
 * lists, on the 2D plan and in the 3D view. Free types typed by a user fall
 * back to the « Autre » style.
 */
export interface AssetTypeStyle {
  name: string;
  icon: IconName;
  color: string;
}

export const ASSET_TYPE_STYLES: readonly AssetTypeStyle[] = [
  { name: 'Chariot', icon: 'cart2', color: '#E0A100' },
  { name: 'Carton', icon: 'box', color: '#A0703C' },
  { name: 'Palette', icon: 'pallet', color: '#8C6239' },
  { name: 'Transpalette', icon: 'palletJack', color: '#E0662F' },
  { name: 'Outillage', icon: 'toolbox', color: '#C9474D' },
  { name: 'Conteneur', icon: 'container', color: '#2557D6' },
  { name: 'Véhicule', icon: 'truck', color: '#5E6B3A' },
  { name: 'Cuve mobile', icon: 'tank', color: '#5B6B7A' },
  { name: 'Pompe', icon: 'pump', color: '#1D7FA8' },
  { name: 'Instrument de mesure', icon: 'gauge', color: '#7B61FF' },
  { name: 'Conteneur isotherme', icon: 'cooler', color: '#0EA5C6' },
  { name: 'Chariot de nettoyage', icon: 'mop', color: '#23917F' },
  { name: 'Dispositif médical', icon: 'medical', color: '#D6336C' },
  { name: 'Autre', icon: 'tag', color: '#6B7785' },
];

export const ASSET_TYPES = ASSET_TYPE_STYLES.map((t) => t.name);

const BY_NAME = new Map(ASSET_TYPE_STYLES.map((t) => [t.name.toLowerCase(), t]));
const OTHER = ASSET_TYPE_STYLES[ASSET_TYPE_STYLES.length - 1]!;

export function assetTypeStyle(type: string | null | undefined): AssetTypeStyle {
  if (!type) return OTHER;
  return BY_NAME.get(type.toLowerCase()) ?? { ...OTHER, name: type };
}

/** Type colour as a number, for Three.js materials. */
export function assetTypeColorNumber(type: string | null | undefined): number {
  return Number.parseInt(assetTypeStyle(type).color.slice(1), 16);
}
